import CreditCardForm from "./CreditCardForm.component.jsx";

export default CreditCardForm;
